<div class="custom-scrollbar-css">
    <ngx-spinner *ngIf="driverPutSpinner == false" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
    type="ball-clip-rotate-multiple" [fullScreen]="true">
    <p style="color: white"> </p>
  </ngx-spinner>
  <h2 class="modal-title" style="margin-top: 3%; margin-left: 65px; font-weight: bold;">
    Édition d'un conducteur : &nbsp; <strong> {{last_name}} {{first_name}} </strong> &nbsp; ID - <strong> {{entry}}
    </strong> </h2>
  <hr style="border: 1px solid #262756;opacity: 0.23;top: 247px;left: 442px;width: 1047px;height: 0px;"/>
  <div class="container-fluid mt-3">
    <form class="mt-4" [formGroup]="registerForm" (submit)="submitFormUpdate()">
      <div [formGroup]="registerForm"  class="container-fluid mt-3">
        <div class="col-5 col-md-10 w-100" style="margin-left: 3%; margin-top: 3%;">
          <h1>Administration</h1>
        </div>
        <div class="row" style="margin-left: 2%;">
              <div class="col-5 col-md-5 w-100">
                <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
                  <mat-label>Nom</mat-label>
                  <input autocomplete="off" matInput value="{{default_branch}}" [(ngModel)]="last_name" formControlName="last_name"
                    class="inputModal" [errorStateMatcher]="matcher" required>
                  <mat-error *ngIf="registerForm.controls['last_name'].invalid"
                    class="elhoo_compte_messageErrorPositionModal">
                    Nom is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-100 mb-3">
                  <mat-label>Date de naissance</mat-label>
                  <input matInput [(ngModel)]="date_birth" [matDatepicker]="picker" formControlName="date_birth"
                    class="inputModal" [errorStateMatcher]="matcher">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error *ngIf="registerForm.controls['date_birth'].invalid"
                    class="elhoo_compte_messageErrorPositionModal">
                    Date de naissance is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-100 mb-3" style="display: none;">
                  <mat-label>Compagnie</mat-label>
                  <mat-select [(ngModel)]="idCompany" formControlName="company_id" class="inputModal"
                    [errorStateMatcher]="matcher">
                    <mat-option *ngFor="let revendeurCompanyId of revendeurCompanyId" [value]="revendeurCompanyId?.id">
                      {{revendeurCompanyId?.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="registerForm.controls['company_id'].invalid"
                    class="elhoo_compte_messageErrorPositionModal">
                    Compagnie is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                
                <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
                  <mat-label>Téléphone</mat-label>
                  <input matInput [(ngModel)]="gsm_number" formControlName="gsm_number" class="inputModal"
                    [errorStateMatcher]="matcher">
                    <mat-icon matSuffix>perm_phone_msg</mat-icon>
                  <mat-error *ngIf="registerForm.controls['gsm_number'].invalid"
                    class="elhoo_compte_messageErrorPositionModal">
                    Téléphone is <strong>required</strong>
                  </mat-error>
                </mat-form-field>

              </div>
              <div class="col-5 col-md-5 w-100" style="margin-left: 10%">
                <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
                  <mat-label>Prénom</mat-label>
                  <input autocomplete="off" matInput value="{{description}}" [(ngModel)]="first_name" formControlName="first_name"
                    class="inputModal" [errorStateMatcher]="matcher">
                  <mat-error *ngIf="registerForm.controls['first_name'].invalid"
                    class="elhoo_compte_messageErrorPositionModal">
                    Prénom is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-100 mb-3">
                  <mat-label>Date permis de conduire</mat-label>
                  <input matInput [(ngModel)]="date_driving_license" [matDatepicker]="picker1"
                    formControlName="date_driving_license" class="inputModal" [errorStateMatcher]="matcher">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                  <mat-error *ngIf="registerForm.controls['date_driving_license'].invalid"
                    class="elhoo_compte_messageErrorPositionModal">
                    Date permis de conduire is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                <mat-radio-group formControlName="civility"  aria-labelledby="example-radio-group-label">
                  <mat-radio-button [value]="0" [checked]="civility !=1"> Homme</mat-radio-button> <br>
                  <mat-radio-button [value]="1" [checked]="civility ==1"> Femme</mat-radio-button>
                </mat-radio-group>
              </div>
        </div>
      </div>
      <div class="row" style="margin-left: 3%;">
        <div class="col-5 col-md-5 w-100">
          <h1 class="p-2">
            Configuration</h1>
          <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
            <mat-label>Dallas</mat-label>
            <input matInput  minlength="10" maxlength="15" [(ngModel)]="dallas" formControlName="dallas" class="inputModal"
              [errorStateMatcher]="matcher" required>
              <mat-icon matSuffix>vpn_key</mat-icon>
            <mat-error *ngIf="registerForm.controls['dallas'].invalid" class="elhoo_compte_messageErrorPositionModal">
              Dallas is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
      <div class=" justify-content-end d-flex" style="margin-right: 5%; margin-bottom: 40px;margin-top: 3%;">
        <!-- <a *ngIf="!registerForm.valid"  class="savebtn mr-2" type="submit"   aria-pressed="true"
        [ngClass]="{'disabled': !registerForm.valid }"  >Enregistrer</a> -->
        <a class="savebtn mr-2"  type="submit"   aria-pressed="true"
        (click)="submitForm()">Enregistrer</a>
      <a class="cancelbtn" type="submit" aria-pressed="true" (click)="onNoClick()">Annuler</a>
    </div>
  </div>
</div>
